import axios from "axios";
import Config from "src/config";

const v1_actionMessengerDeletarTemplate = (clienteId, templateId) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/messenger/templates/${templateId}`
    });
};

export default v1_actionMessengerDeletarTemplate;
